<div class="wrapper">
  <ng-container *ngFor="let rootToolTip of toolTips$ | async">
    <ng-container *ngTemplateOutlet="items; context: { item: rootToolTip }"></ng-container>
    <div class="divider"></div>
  </ng-container>
</div>

<!--
  Template for each row.
  Notice that we use a recursive *ngTemplateOutlet pattern to go through the tree-like structure of the tool tip
  information objects.
-->
<ng-template #items let-item="item">
  <ng-container *ngIf="item.children.length === 0">
    <span
      >{{ item.name }}: {{ item.value }}<span *ngIf="item.measurementUnitTextId">{{ item.measurementUnitTextId | translate }}</span></span
    >
  </ng-container>
  <ng-container *ngIf="item.children.length > 0">
    <span>{{ item.name }}:</span>
    <ng-container *ngFor="let child of item.children">
      <ng-container *ngTemplateOutlet="items; context: { item: child }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>
